import { TEXT } from './00_assets_types'

const ES =
{
  [ TEXT.UI_MENU_USERS         ]: 'Bruker'
, [ TEXT.UI_MENU_CLIENTS       ]: 'Klienter'
, [ TEXT.UI_MENU_WORKGROUPS    ]: 'Arbeidsgrupper'
, [ TEXT.UI_MENU_JOBS          ]: 'Oppgaver'
, [ TEXT.UI_MENU_KEY_MASTERING  ]: 'Hovednøkkel'

, [ TEXT.UI_BUTTON_CREATE      ]: 'Skape'
, [ TEXT.UI_BUTTON_NEW         ]: 'Ny'
, [ TEXT.UI_BUTTON_OK          ]: 'Ok'
, [ TEXT.UI_BUTTON_CANCEL      ]: 'Avbryt'
, [ TEXT.UI_BUTTON_SAVE        ]: 'Lagre'
, [ TEXT.UI_BUTTON_LOGIN       ]: 'Logg Inn'
, [ TEXT.UI_BUTTON_SEND        ]: 'Sende'


, [ TEXT.UI_EMAIL              ]: 'e-post'
, [ TEXT.UI_ROLE               ]: 'Rolle'
, [ TEXT.UI_USERNAME           ]: 'Bruker'
, [ TEXT.UI_NAME               ]: 'Navn'
, [ TEXT.UI_DATE               ]: 'Dato'
, [ TEXT.UI_ADDR               ]: 'Adresse'
, [ TEXT.UI_DESC               ]: 'Beskrivelse'
, [ TEXT.UI_PRICE              ]: 'Pris'
, [ TEXT.UI_NO_DATA            ]: 'Ingen data'
, [ TEXT.UI_MACHINES           ]: 'Maskiner'
, [ TEXT.UI_USERS              ]: 'Bruker'
, [ TEXT.UI_DATE_FORMAT        ]: 'DD/MM/YYYY' // ES - date format Locale
, [ TEXT.UI_SING_OUT           ]: 'Logg ut'
, [ TEXT.UI_MKS_TYPE           ]: 'Type hovednøkkel'
, [ TEXT.UI_KEY_APP            ]: 'Nøkkelbruk'
, [ TEXT.UI_CLIENT             ]: 'Klient'
, [ TEXT.UI_FILE               ]: 'Fil'
, [ TEXT.UI_SELECT_FILE        ]: 'Velg Fil'


, [ TEXT.UI_LOGIN_USERNAME     ]: 'Brukernavn'
, [ TEXT.UI_LOGIN_CLOUDNAME    ]: 'Sky'
, [ TEXT.UI_LOGIN_PASSWORD     ]: 'Passord'



, [ TEXT.ARE_YOU_SURE          ]: 'Er du sikker?'


, [ TEXT.ERROR_NONE            ]: ''
, [ TEXT.ERROR_LOGIN_FORBIDDEN ]: 'Feil bruker / sky eller passord'
, [ TEXT.ERROR_LOGIN_UNAUTHORIZED ]: 'Feil bruker / sky eller passord'
, [ TEXT.ERROR_INTERNAL        ]: 'Intern server feil'
, [ TEXT.ERROR_FORBIDDEN       ]: 'Ingen tilgang'
, [ TEXT.ERROR_UNKNOWN         ]: 'Det var en feil, og det er alt vi vet'

, [ TEXT.PAGE_NOT_FOUND        ]: 'Side ikke funnet'

, [ TEXT.WORKGROUPS_NEW_TITLE  ]: 'Ny arbeidsgruppe'
, [ TEXT.WORKGROUPS_EDIT_TITLE ]: 'Rediger arbeidsgruppe'
, [ TEXT.WORKGROUPS_NAME       ]: 'Navn'


, [ TEXT.USERS_NEW_TITLE       ]: 'Ny bruker'
, [ TEXT.USERS_EDIT_TITLE      ]: 'Rediger bruker'


, [ TEXT.MACHINE_TYPE          ]: 'Maskintype'
, [ TEXT.MACHINE_NUM_JOBS      ]: '# oppgaver'
, [ TEXT.MACHINE_NAME          ]: 'Maskin'


, [ TEXT.CLIENT_NEW_TITLE      ]: 'Ny klient'
, [ TEXT.CLIENT_EDIT_TITLE     ]: 'Rediger klient'
, [ TEXT.CLIENT_ADDRESS        ]: 'Adresse'
, [ TEXT.CLIENT_CONTACT        ]: 'Kontakt'
, [ TEXT.CLIENT_CONTACT_EMAIL  ]: 'e-post'
, [ TEXT.CLIENT_CONTACT_PHONE  ]: 'Telefon'
, [ TEXT.CLIENT_CONTACT_FAX    ]: 'Faks/Tlf'
, [ TEXT.CLIENT_SURNAMES       ]: 'Etternavn'
, [ TEXT.CLIENT_BIRTHDAY       ]: 'Fødselsdag'
, [ TEXT.CLIENT_NOTES          ]: 'Merknader'
, [ TEXT.CLIENTS_FILTER_BY_NAME ]: 'Filternavn'
, [ TEXT.CLIENTS_FILTER_BY_ADDR ]: 'Filtrer adresse'
, [ TEXT.CLIENTS_FILTER_BY_CONTACT ]: 'Filtrer kontakt'
, [ TEXT.CLIENT_ADDR_STREET1   ]: 'Adresse'
, [ TEXT.CLIENT_ADDR_STREET2   ]: ''
, [ TEXT.CLIENT_ADDR_CITY      ]: 'By'
, [ TEXT.CLIENT_ADDR_PROVINCE  ]: 'Provins'
, [ TEXT.CLIENT_ADDR_ZIP_CODE  ]: 'Post kode'
, [ TEXT.CLIENT_ADDR_COUNTRY   ]: 'Land'


, [ TEXT.MACHINES_NEW          ]: 'Ny maskin'
, [ TEXT.MACHINE_SERIAL_NO     ]: 'Serienummer'

, [ TEXT.JOB_EDIT_TITLE        ]: 'Rediger oppgave'
, [ TEXT.JOB_NEW_TITLE         ]: 'Ny oppgave'
, [ TEXT.JOB_KEY_TYPE          ]: 'Nøkkeltype'
, [ TEXT.JOB_NUM_KEYS          ]: 'Beløp'
, [ TEXT.JOB_MACHINE           ]: 'Maskin'
, [ TEXT.JOB_STATUS            ]: 'Status'
, [ TEXT.JOB_DATE              ]: 'Dato'
, [ TEXT.JOB_QUANTITY          ]: 'Nytt beløp'
, [ TEXT.JOB_FILTER_BY_STATUS  ]: 'Filtrer etter status'
, [ TEXT.JOB_FILTER_BY_CLIENT  ]: 'Filtrer klienter'
, [ TEXT.JOB_FILTER_BY_MACHINE_NAME ]: 'Filtermaskin'
, [ TEXT.JOB_FILTER_BY_KEY_TYPE]: 'Nøkkelfilter'
, [ TEXT.JOB_FILTER_BY_DATE    ]: 'Filterdato'

, [ TEXT.KEY_MASTERING_LAUNCH   ]: 'Start'
, [ TEXT.KEY_MASTERING_LAUNCH_N ]: 'Start ({num})'
, [ TEXT.KEY_MASTERING_NEW_TITLE ]: 'Last opp hovednøkkel'
, [ TEXT.KEY_MASTERING_WILL_CREATE_N_KEYS ]: '{num} nøkler opprettes. Er du sikker?'
, [ TEXT.KEY_MASTERING_KEYS_CREATED       ]: '{num} jobb (er) er opprettet'
, [ TEXT.KEY_MASTERING_NAME               ]: 'navn hovednøkkel'

, [ TEXT.LOGIN_FORGOT_PASSWORD_QUESTION ]: 'Glemt passord?'
, [ TEXT.LOGIN_FORGOT_PASSWORD_TITLE ]: 'Sendte hvileinstruksjoner til'
, [ TEXT.LOGIN_SLOGAN                   ]: 'Den første skybaserte nøkkel duplisering-appen'
, [ TEXT.LOGIN_QUALITY_POINTS           ]: `
<br>
<br>
<p class="login-quality-call mb-4">
  <strong>THE FUTURE OF KEY DUPLICATION</strong>
</p>
<ul class="login-sell-points">
  <li>Registrer duplikater av nøkler som er kopiert for kundene dine</li>
  <br>
  <li>Lagre data uten risiko for å miste dem og få tilgang til dem fra hvor som helst</li>
  <br>
  <li>Automatiske oppdateringer</li>
</ul>
`

, [ TEXT.LEGAL_TOS_TEXT              ]: 'Juridisk varsel'
, [ TEXT.LEGAL_PRIVACY_TEXT          ]: 'Personvern'
, [ TEXT.LEGAL_MODEL_TEXT            ]: 'Avtalemodell'
, [ TEXT.LEGAL_TOS_LINK              ]: '/legal/no/legal_notice_no.pdf'
, [ TEXT.LEGAL_PRIVACY_LINK          ]: '/legal/no/privacy_policy_no.pdf'
, [ TEXT.LEGAL_MODEL_LINK            ]: '/legal/no/model_no.docx'

, [ TEXT.KEY_MODEL                   ]: 'nøkkel'
, [ TEXT.KEY_SERIES                  ]: 'Serie'
, [ TEXT.KEY_CODE                    ]: 'Kode'
, [ TEXT.KEY_DATA_SHEET              ]: 'Fil'
, [ TEXT.KEY_BITING                  ]: 'Biting'
, [ TEXT.KEY_APPLICATION             ]: 'Applikasjon'

, [ TEXT.ENUM_JOB_STATE_PENDING      ]: 'AVVENTER'
, [ TEXT.ENUM_JOB_STATE_CANCELLED    ]: 'AVBRUTT'
, [ TEXT.ENUM_JOB_STATE_COMPLETE     ]: 'FULLSTENDIG'
, [ TEXT.ENUM_JOB_STATE_PROCESSING   ]: 'BEHANDLING'

, [ TEXT.ENUM_USER_ROLE_ADMIN        ]: 'ADMIN'
, [ TEXT.ENUM_USER_ROLE_MANAGER      ]: 'MANAGER'
, [ TEXT.ENUM_USER_ROLE_USER         ]: 'USER'

, [ TEXT.ENUM_KEY_APP_CAR            ]: 'BIL'
, [ TEXT.ENUM_KEY_APP_HOME           ]: 'HJME'
, [ TEXT.ENUM_KEY_APP_SECURITY       ]: 'SIKKERHET'
, [ TEXT.ENUM_KEY_APP_LOCK           ]: 'HENGELÅS'
, [ TEXT.ENUM_KEY_APP_UNSPECIFIED    ]: 'USPESIFISERTE'

, [ TEXT.FORM_HAS_ERRORS             ]: 'Vennligst fyll ut obligatoriske felt i rødt'
}

export default ES ;
